import { Component } from '@angular/core';
import { Product } from '../product';
import { CommonModule } from '@angular/common';
import { Navbar } from '../../components/navbar/navbar';
import { RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-product-list',
  imports: [
    CommonModule,
    Navbar,
    RouterModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    TranslateModule
  ],
  templateUrl: './product-list.html',
  styleUrl: './product-list.scss',
})
export class ProductList {
  constructor(private productService: Product) {}
  products: any[] = [];
  productsPlan: any[] = [];
  nameIcon: string = '';

  activeTab = '';

  productId: any;
  productsAllPlan: any = [];

  setTab(tab: string) {
    if (tab == '') {
      console.log('tab', tab);
      this.activeTab;
    }

    this.activeTab = tab;
  }

  currentIndex = 0;
  intervalId: any;

  planId: any[] = [];
  productsOptions: any[] = [];
  amountOption: any[] = [];

  planName: any;

  result: any;
  allProdId: any;
  loading: boolean = true;
  ngOnInit(): void {
    this.productService.findAllProducts().subscribe((res: any) => {
      this.products = res;
    });

    this.productService.findAllProductsPlan().subscribe((res: any) => {
      this.productsAllPlan = res;
      this.loading = false;
    });
  }
}
